export const GET_LOBBYISTS = "GET_LOBBYISTS"
export const GET_LOBBYIST_LIST_ITEMS = "GET_LOBBYIST_LIST_ITEMS"
export const GET_LOBBYIST = "GET_LOBBYIST"
export const GET_CHANGES_REQUIRED = "GET_CHANGES_REQUIRED"
export const ADD_ACTIVE_LOBBYIST_GRID_INDEX = "ADD_ACTIVE_LOBBYIST_GRID_INDEX"
export const REMOVE_ACTIVE_LOBBYIST_GRID_INDEX = "REMOVE_ACTIVE_LOBBYIST_GRID_INDEX"


// WEBPACK FOOTER //
// ./src/actionTypes/lobbyist.js